import type { AddSelectionAreaToPlan } from "./types";

export const addSelectionAreaToPlan: AddSelectionAreaToPlan = ({
  plan,
  area,
}) => ({
  ...plan,
  selectionAreas: [...plan.selectionAreas, area],
});
